import Logo from './logo.png';
import PropTypes from 'prop-types';
import React from 'react';

import './Header.css';

function Header(_ref) {
  var children = _ref.children;

  return React.createElement(
    'div',
    { className: 'Header' },
    React.createElement('img', { alt: '', src: Logo }),
    React.createElement('hr', null),
    children,
    React.createElement('hr', null)
  );
}

Header.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any
} : {};

export default Header;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Header/Header.js
// module id = 699
// module chunks = 0